import { Injectable } from '@angular/core';
import { EventLoggerService } from './event-logger-service';
import * as Sentry from '@sentry/angular';

@Injectable({
	providedIn: 'root',
})
export default class SentryEventLoggerService implements EventLoggerService {
	public logEvent(message: string, payload?: Record<any, any>): void {
		return Sentry.logger.info(message, {
			...(payload ?? {}),
			message,
		});
	}
}
